module.exports = __webpack_public_path__ + "static/img/Tyson-Stengle.62c9f2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tyson-Stengle.jpg
// module id = hdST
// module chunks = 0